export default function Marquee({ items, className = "" }) {
  return (
    <div
      className={`marquee-band border-y border-navy/10 bg-mist py-6 ${className}`}
      data-testid="marquee-band"
    >
      <div className="marquee-track">
        {[false, true].map((dup) => (
          <ul
            key={String(dup)}
            aria-hidden={dup || undefined}
            className="marquee-list"
          >
            {items.map((item, i) => (
              <li key={i} className="marquee-item">
                <span className="px-7 font-serif text-xl italic text-navy/70 sm:text-2xl">
                  {item}
                </span>
                <span
                  aria-hidden="true"
                  className="inline-block h-1.5 w-1.5 rotate-45 bg-gold"
                />
              </li>
            ))}
          </ul>
        ))}
      </div>
    </div>
  );
}
